import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightLeft } from "@fortawesome/free-solid-svg-icons";
import ScwLogo from "../../../assets/scw_logo.svg";
import PortalPanel from "./PortalPanel";

// Mobile-only "Signing Into … / Change" footer shown at the bottom of the auth
// screens' form column (hidden on md+, where the desktop banner shows it). The
// "Change" button opens the same portal panel as the desktop banner.
// Uses -mx-5 / -mb-4 to break out of the form column's px-5 py-4 padding.
const AuthMobileFooter: React.FC = () => {
  const [showPortalPanel, setShowPortalPanel] = useState(false);

  return (
    <>
      <div className="md:hidden mt-auto -mx-5 -mb-4 px-5 py-3 bg-[#003366] text-white flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img
            src={ScwLogo}
            width={44}
            height={44}
            alt="scw-logo"
            className="h-10 w-10 bg-white rounded-full p-1.5 object-contain"
          />
          <div className="leading-tight">
            <p className="text-[10px] tracking-[0.2em] text-white/70 uppercase">
              Signing Into
            </p>
            <p className="text-sm font-semibold">Senior Citizens Welfare</p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setShowPortalPanel(true)}
          className="flex items-center gap-2 border border-gray-400 text-gray-200 rounded-md px-3 py-2 text-xs hover:bg-white/10 transition-colors"
        >
          <FontAwesomeIcon icon={faRightLeft} size="sm" />
          Change
        </button>
      </div>

      <PortalPanel
        open={showPortalPanel}
        onClose={() => setShowPortalPanel(false)}
      />
    </>
  );
};

export default AuthMobileFooter;
